import store from "../../store";

// New Action methods
export const initActiveEditor =
  (
    activeEditorState,
    activeComponent,
    activeComponentInfo,
    activeClauseOptionValueId,
  ) =>
  dispatch => {
    const {
      DocumentStore: { preventClickedComponentIdUpdate },
      EditorStore: {
        activeComponent: oldActiveComponent,
        activeEditorState: olaActiveEditorState,
        activeComponentInfo: oldActiveComponentInfo,
      },
    } = store.getState();
    if (
      !preventClickedComponentIdUpdate &&
      oldActiveComponent &&
      oldActiveComponentInfo &&
      oldActiveComponentInfo.tableCellId !== activeComponentInfo.tableCellId &&
      olaActiveEditorState
    ) {
      dispatch({
        type: "UPDATE_COMPONENT_EDITOR_STATE",
        payload: {
          componentMeta: oldActiveComponentInfo,
          editorState: olaActiveEditorState,
        },
      });
      dispatch({ type: "NUKE_ACTIVE_EDITOR" });
    }
    dispatch({
      type: "INIT_ACTIVE_EDITOR",
      payload: {
        activeEditorState,
        activeComponent,
        activeComponentInfo,
        activeClauseOptionValueId,
      },
    });
  };

export const updateActiveEditorState =
  (activeEditorState, activeComponentInfo) => dispatch => {
    const {
      EditorStore: { activeComponent, activeComponentInfo: componentInfo },
    } = store.getState();
    if (activeComponent && componentInfo) {
      dispatch({
        type: "UPDATE_ACTIVE_EDITOR_STATE",
        payload: { activeEditorState, activeComponentInfo },
      });
    }
  };

export const updateActiveComponent = activeComponent => dispatch => {
  const {
    EditorStore: { activeComponentInfo },
  } = store.getState();
  if (activeComponentInfo) {
    dispatch({
      type: "UPDATE_ACTIVE_COMPONENT",
      payload: activeComponent,
    });
  }
};

/**
 * @param {*} activeComponentId :: component where to update the editor state
 * @param {*} editorState :: latest editor state
 * -------------
 * PURPOSES :: this action method will be used in a scenarios where there is a need to update the
 * local editor state of text or table cell.
 * ex 1. Clause Option Case :: when create/update/delete clause options,
 *       have to update the local editor state also to reflect the changes
 * ex 2. Form Fields Case :: in case of form document when CURD form fields, have to update the local editor state also
 * ex 3. Undo/Redo Case :: in undo/redo cases need to update the local editor state
 */
export const forceUpdateLocalEditorState = payload => dispatch => {
  dispatch({
    type: "FORCE_UPDATE_LOCAL_EDITOR_STATE",
    payload,
  });
};

export const nukeActiveEditor =
  (updateEditorStateInComponent, updateLocalEditorStateAlso) => dispatch => {
    const {
      EditorStore: {
        activeEditorState,
        activeComponent,
        activeComponentInfo,
        lastEditorChangeTime,
      },
    } = store.getState();

    if (updateEditorStateInComponent) {
      if (
        activeEditorState &&
        activeComponent &&
        activeComponentInfo &&
        (activeComponentInfo.blockType === "BODY" ||
          activeComponentInfo.blockType === "HEADER" ||
          activeComponentInfo.blockType === "FOOTER" ||
          activeComponentInfo.blockType === "COVERPAGE")
      ) {
        dispatch({
          type: "UPDATE_COMPONENT_EDITOR_STATE",
          payload: {
            componentMeta: activeComponentInfo,
            editorState: activeEditorState,
          },
        });
      }
    }
    if (
      updateLocalEditorStateAlso &&
      activeEditorState &&
      activeComponent &&
      activeComponentInfo
    ) {
      dispatch({
        type: "FORCE_UPDATE_LOCAL_EDITOR_STATE",
        payload: {
          componentId:
            activeComponentInfo.tableCellId || activeComponentInfo.componentId,
          editorState: activeEditorState,
        },
      });
    }
    if (
      activeEditorState ||
      activeComponent ||
      activeComponentInfo ||
      lastEditorChangeTime
    ) {
      dispatch({ type: "NUKE_ACTIVE_EDITOR" });
    }
  };

export const updateActiveEditoInfo = payload => dispatch => {
  const {
    EditorStore: { activeEditorState, activeComponent, activeComponentInfo },
  } = store.getState();
  if (activeEditorState && activeComponent && activeComponentInfo) {
    dispatch({
      type: "UPDATE_ACTIVE_EDITOR_INFO",
      payload,
    });
  }
};

export const updateEditorHighlightSelection =
  highlightedContent => dispatch => {
    dispatch({
      type: "UPDATE_EDITOR_HIGHLIGHT_SELECTION",
      payload: highlightedContent,
    });
  };
